import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

export default function Testimonials() {
  const { content, locale } = useContent();
  const data = content.testimonials || {};
  const items = data.items || [];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="section bg-bg-secondary border-y border-line"
    >
      <div className="container-x">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <p className="text-eyebrow mb-4">{pickLocale(data.eyebrow, locale)}</p>
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95]" data-testid="testimonials-title">
            {pickLocale(data.title, locale)}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-bg border border-line rounded-md p-8 md:p-10 flex flex-col gap-6 hover:border-acid/40 transition-colors"
            >
              <Quote className="text-acid" size={28} strokeWidth={1.2} />
              <blockquote className="font-display text-xl md:text-2xl text-ink leading-snug flex-1">
                “{pickLocale(t.quote, locale)}”
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-3 border-t border-line">
                {t.photo ? (
                  <img loading="lazy" decoding="async" src={t.photo} alt={t.author} className="w-10 h-10 rounded-full object-cover grayscale" />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-bg-surface border border-line flex items-center justify-center text-ink-muted text-xs font-mono uppercase">
                    {(t.author || '').split(' ').map(s => s[0]).join('').slice(0, 2)}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-ink truncate">{t.author}</div>
                  <div className="text-eyebrow text-ink-muted truncate">{pickLocale(t.role, locale)} · {t.brand}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
